import {useAppDispatch, useAppSelector} from '../store/hooks';
import {
  findBy,
  genMnemonic,
  getById,
  getUserData,
  sendChatMessage,
  writeItem,
} from '../api';
import {Auction, FolderType, Media} from '../types';
import {
  setAppDialogParams,
  setFolderMenuItemId,
} from '../store/slices/ui';
import {useMutation} from 'react-query';
import uuid from 'react-native-uuid';
import {SellDialogBody} from '../components/auction/selldialogbody';
import {useCloseDialog} from './useCloseDialog';
import {
  NavigationProp,
  useNavigation,
} from '@react-navigation/native';
import {FileStackParams} from '../types/nav';
import {
  setAuctioName,
  setAuctionBetStep,
  setAuctionPrice,
} from '../store/slices/auction';

export function useAuction() {
  const dispatch = useAppDispatch();

  const navigation = useNavigation<NavigationProp<FileStackParams>>();
  const {closeDialog} = useCloseDialog();
  const {
    newAuctionName: title,
    newAuctionPrice: minPrice,
    newAuctionWallet,
    newAuctionBetStep,
  } = useAppSelector(state => state.auction);
  const startAuctionMutation = useMutation(
    async (media: Media) => {
      const user = await getUserData();
      const auctionId = uuid.v4().toString();
      const nmedia: Media = JSON.parse(JSON.stringify(media));
      delete nmedia.url;
      delete nmedia.torrentFile;
      // nmedia.folderId = auctionId;
      nmedia.isAuctionMedia = true;
      const newAuction: Auction = {
        id: auctionId,
        mediaId: media.id,
        minPrice,
        title,
        isFolder: true,
        date: new Date().valueOf(),
        mnemonic: genMnemonic(),
        wallet: newAuctionWallet,
        userId: user.id,
        minStep: newAuctionBetStep,
        authorName: user.name,
        isAuction: true,
        folderType: FolderType.auction,
        orderId: 1,
        media: nmedia,
      };
      console.info('newAuction', newAuction);
      if (newAuction.wallet === '') throw 'invalid_wallet';
      await writeItem(newAuction);
      await writeItem({...newAuction, folderId: auctionId});

      await sendChatMessage(
        auctionId,
        user.name + ' has created auction ' + title,
        newAuction.mnemonic,
        {system: true},
      );

      return newAuction;
    },
    {
      onSuccess: ({id, mnemonic, title}) =>
        navigation.navigate('Auction', {
          auctionId: id,
          mnemonic,
          title,
        }),
    },
  );
  const onSellPress = async (mediaId: string, folderId: string) => {
    dispatch(setFolderMenuItemId({itemId: undefined}));
    dispatch(setAuctionPrice(0.1));
    dispatch(setAuctionBetStep(0.1));
    const media = (await getById(mediaId, folderId)) as Media;
    dispatch(setAuctioName(media.filename));
    const auctionItems = await findBy('mediaId', mediaId);
    if (auctionItems.length) {
      const {id, mnemonic, title} = auctionItems[0];
      navigation.navigate('Auction', {
        auctionId: id,
        mnemonic,
        title,
      });
      return;
    }
    dispatch(
      setAppDialogParams({
        appDialogVisible: true,
        appDialogTitle: `Sell Media`,
        appDialogIcon: 'currency-btc',
        appDialogOnSelectRight: async () => {
          startAuctionMutation.mutateAsync(media);
          closeDialog();
        },
        appDialogOnSelectLeftt: undefined,
        appDialogBody: SellDialogBody,
        appDialogControls: undefined,
        appDialogLoading: false,
      }),
    );
  };
  return {
    onSellPress,
  };
}
